import { render, staticRenderFns } from "./PaymentLinkStep.vue?vue&type=template&id=212be318&scoped=true"
import script from "./PaymentLinkStep.vue?vue&type=script&lang=js"
export * from "./PaymentLinkStep.vue?vue&type=script&lang=js"
import style0 from "./PaymentLinkStep.vue?vue&type=style&index=0&id=212be318&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212be318",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('212be318')) {
      api.createRecord('212be318', component.options)
    } else {
      api.reload('212be318', component.options)
    }
    module.hot.accept("./PaymentLinkStep.vue?vue&type=template&id=212be318&scoped=true", function () {
      api.rerender('212be318', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/online-transaction/components/PaymentLinkStep.vue"
export default component.exports